module.exports = __webpack_public_path__ + "img/Command_Query_Responsibility_Segregation.746f21b4.jpeg";